import {AccessibleGridCell} from 'constants/SampleConstants';
import {FillDirection} from 'lookup-config/LookupConfigModalConstants';
import {ScanToMoveCellByCoordinates} from 'samples/grids/ScanToMoveGridUtil';

export enum GridUIActionType {
  SET_SELECTED_CELLS = 'SET_SELECTED_CELLS',
  OPEN_GRID = 'OPEN_GRID',
  CLOSE_GRID = 'CLOSE_GRID',
  SET_SCAN_MODE = 'SET_SCAN_MODE',
  SET_SCAN_MODE_CELLS = 'SET_SCAN_MODE_CELLS',
  SET_SCANNING_COORDINATES = 'SET_SCANNING_COORDINATES',
  SET_FILL_DIRECTION = 'SET_FILL_DIRECTION',
}

interface OpenGridAction {
  type: GridUIActionType.OPEN_GRID;
  gridId: string;
}
export function openGrid(gridId: string): OpenGridAction {
  return {
    type: GridUIActionType.OPEN_GRID,
    gridId,
  };
}

interface CloseGridAction {
  type: GridUIActionType.CLOSE_GRID;
  gridId: string;
}
export function closeGrid(gridId: string): CloseGridAction {
  return {
    type: GridUIActionType.CLOSE_GRID,
    gridId,
  };
}

interface SetScanModeAction {
  type: GridUIActionType.SET_SCAN_MODE;
  gridId: string;
  isScanMode: boolean;
}
export function setIsScanMode(gridId: string, isScanMode: boolean): SetScanModeAction {
  return {
    type: GridUIActionType.SET_SCAN_MODE,
    gridId,
    isScanMode,
  };
}

interface SetSelectedCellsAction {
  type: GridUIActionType.SET_SELECTED_CELLS;
  gridId: string;
  cells: Array<AccessibleGridCell>;
}
export function setSelectedCells(gridId: string, cells: Array<AccessibleGridCell>): SetSelectedCellsAction {
  return {
    type: GridUIActionType.SET_SELECTED_CELLS,
    gridId,
    cells,
  };
}

interface SetScanModeCellsAction {
  type: GridUIActionType.SET_SCAN_MODE_CELLS;
  gridId: string;
  scanModeCells: ScanToMoveCellByCoordinates | null;
}
export function setScanModeCells(
  gridId: string,
  scanModeCells: ScanToMoveCellByCoordinates | null
): SetScanModeCellsAction {
  return {
    type: GridUIActionType.SET_SCAN_MODE_CELLS,
    gridId,
    scanModeCells,
  };
}

interface SetScanningCoordinatesAction {
  type: GridUIActionType.SET_SCANNING_COORDINATES;
  gridId: string;
  scanningCoordinates: string;
}
export function setScanningCoordinates(
  gridId: string,
  scanningCoordinates: string
): SetScanningCoordinatesAction {
  return {
    type: GridUIActionType.SET_SCANNING_COORDINATES,
    gridId,
    scanningCoordinates,
  };
}

interface SetFillDirectionAction {
  type: GridUIActionType.SET_FILL_DIRECTION;
  gridId: string;
  fillDirection: FillDirection;
}
export function setFillDirection(gridId: string, fillDirection: FillDirection): SetFillDirectionAction {
  return {
    type: GridUIActionType.SET_FILL_DIRECTION,
    gridId,
    fillDirection,
  };
}

export type GridUIAction =
  | OpenGridAction
  | CloseGridAction
  | SetSelectedCellsAction
  | SetScanModeCellsAction
  | SetScanModeAction
  | SetScanningCoordinatesAction
  | SetFillDirectionAction;
